import React, { Component } from 'react';
import _ from 'lodash';
import { Helmet } from 'react-helmet';
import { ListBox } from '@mescius/wijmo.react.input';
import '@mescius/wijmo.styles/wijmo.css';

import { MasterPageHeader } from '../components/PageHeader';
import { Description } from '../components/Description';
import { CloseEditView } from '../components/CloseEditView';
import { HeaderMenu, ToolTip } from '../components/ProgressBase';
import { RadioButtonIcon } from '../components/icons/RadioButtonIcon';
import { ProgressConfirmDialog } from '../components/modals/ProgressConfirmDialog';
import {
  InputForm,
  FormElement,
  FormList,
  FormListItem,
  FormListSubHeader,
} from '../components/CommonFormComponents';
import { Information } from '../components/modals/common';
import ProgressService from '../services/Progress';
import FieldService from '../services/Fields';
import FieldItemService from '../services/FieldItems';
import SessionStorageService from '../services/utilities/SessionStorageService';
import dialogLoader from '../utilities/dialogLoader';
import {
  NUMBER_OF_FIELD_ITEM_TYPE,
  INIT_NUMBER_OF_INSTANCE,
  MAX_NUMBER_OF_INSTANCES,
  HEADER_CONSTANTS_PROGRESS,
  TITLE_BROWSER_PROGRESS,
  DISPLAY_FLAG,
} from '../utilities/constants';
import { messageUtility } from '../utilities/messageUtility';
import IconProgress from '../images/icon-progress.svg';

const defaultParams = {
  field_main_work_type_id: null,
  field_sub_work_type_id: null,
  a_item_list_select_flag: false,
  b_item_list_select_flag: false,
  c_item_list_select_flag: false,
  d_item_list_select_flag: false,
  a_item_ids: [],
  b_item_ids: [],
  c_item_ids: [],
  d_item_ids: [],
  a_item_list_required_flag: false,
  b_item_list_required_flag: false,
  c_item_list_required_flag: false,
  d_item_list_required_flag: false,
  man_day_input_flag: false,
};

/**
 * 工種ごと設定画面
 *  @props {number}view.state.id: 大工種ID
 */
export class ProgressSettingLocation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldMainWorkType: {},
      fieldSubWorkType: {},
      isDisplay: false,
      isSubWorkType: false,
      selectedName: null,
      defaultRequired: [],
      defaultCheckedIdInstances: [],
      defaultListLocation: [],
      visibleConfirmDialog: false,
      deletedItems: [],
      isShowPopupError: false,
      messageError: '',
      params: defaultParams,
      allClassItems: [],
      keyRender: true,
      isInvalidOfInstances: false,
      titleMainSub: '',
    };
    this.GoBack = {
      callback: {
        close: () => {
          dialogLoader.close();
        },
        clear: () => {
          window.location.replace('/progress/0/0/0/ProgressSetting:1/0:0');
        },
      },
    };
    this.isSubmitingFlag = false;
    this.isVisibleConfirmDialog = false;
    this.fieldId = SessionStorageService.getFieldId();
    this.isProgressFlg = parseInt(SessionStorageService.getUseProgressFlag());
    this.strongNotification = SessionStorageService.getStrongtNotificationCount();
    this.isCheckingCheckBoxFlag = false;
    this.listBoxClassA = null;
    this.listBoxClassB = null;
    this.listBoxClassC = null;
    this.listBoxClassD = null;
    this.validateAndRequireItems = [
      {
        id: NUMBER_OF_FIELD_ITEM_TYPE.itemA,
        validateMessage: null,
        placeItemRequiredFlag: false,
      },
      {
        id: NUMBER_OF_FIELD_ITEM_TYPE.itemB,
        validateMessage: null,
        placeItemRequiredFlag: false,
      },
      {
        id: NUMBER_OF_FIELD_ITEM_TYPE.itemC,
        validateMessage: null,
        placeItemRequiredFlag: false,
      },
      {
        id: NUMBER_OF_FIELD_ITEM_TYPE.itemD,
        validateMessage: null,
        placeItemRequiredFlag: false,
      },
    ];
  }

  async componentDidMount() {
    if (!this.isProgressFlg) {
      return window.location.replace('/error-permission');
    }
    await this.getListClassLocation();
    await this.getWorkTypeSettings();
    this.setMaxHeightTable();
  }

  updateWorkTypeSettings = async () => {
    if (this.isSubmitingFlag) {
      return;
    }
    this.isSubmitingFlag = true;
    const response = await ProgressService.updateProgressWorkTypeSettings(
      this.fieldId,
      this.state.params
    );
    this.isSubmitingFlag = false;
    if (response.result) {
      return this.GoBack.callback.clear();
    } else {
      const message =
        _.get(response, 'data.message') ||
        messageUtility.getMessage('E-000-001');
      this.setState({
        isShowPopupError: true,
        messageError: message,
        visibleConfirmDialog: false,
      });
    }
  };

  getWorkTypeSettings = async () => {
    const objectId = SessionStorageService.getWorkTypeSetting();
    let field_main_work_type_id = null;
    let field_sub_work_type_id = null;
    if (objectId) {
      field_main_work_type_id = objectId['field_main_work_type_id'];
      if (objectId['field_sub_work_type_id']) {
        field_sub_work_type_id = objectId['field_sub_work_type_id'];
      }
    }
    const response = await ProgressService.getProgressWorkTypeSettings(
      this.fieldId,
      {
        field_main_work_type_id,
        field_sub_work_type_id,
      }
    );
    if (response.result) {
      let {
        field_main_work_type,
        field_sub_work_type,
        a_item_list_select_flag,
        b_item_list_select_flag,
        c_item_list_select_flag,
        d_item_list_select_flag,
        a_item_ids,
        b_item_ids,
        c_item_ids,
        d_item_ids,
        a_item_list_required_flag,
        b_item_list_required_flag,
        c_item_list_required_flag,
        d_item_list_required_flag,
        man_day_input_flag,
      } = _.get(response, 'data.entities.progress_work_type_settings');
      const allClassItems = _.cloneDeep(this.state.allClassItems);
      const defaultRequired = _.cloneDeep(this.state.defaultRequired);
      let defaultCheckedIdInstances = _.cloneDeep(
        this.state.defaultCheckedIdInstances
      );
      const listItems = [
        {
          id: NUMBER_OF_FIELD_ITEM_TYPE.itemA,
          isChecked: a_item_list_select_flag,
          isRequired: a_item_list_required_flag,
          listIdsInstance: a_item_ids,
        },
        {
          id: NUMBER_OF_FIELD_ITEM_TYPE.itemB,
          isChecked: b_item_list_select_flag,
          isRequired: b_item_list_required_flag,
          listIdsInstance: b_item_ids,
        },
        {
          id: NUMBER_OF_FIELD_ITEM_TYPE.itemC,
          isChecked: c_item_list_select_flag,
          isRequired: c_item_list_required_flag,
          listIdsInstance: c_item_ids,
        },
        {
          id: NUMBER_OF_FIELD_ITEM_TYPE.itemD,
          isChecked: d_item_list_select_flag,
          isRequired: d_item_list_required_flag,
          listIdsInstance: d_item_ids,
        },
      ];

      _.forEach(allClassItems, item => {
        const index = _.findIndex(listItems, val => _.isEqual(val.id, item.id));
        item.isChecked = listItems[index].isChecked;
        item.listInstances = [];
        this.validateAndRequireItems[index].placeItemRequiredFlag =
          listItems[index].isRequired;
      });
      _.forEach(listItems, item => {
        defaultRequired.push({
          id: item.id,
          required: item.isRequired,
        });
        defaultCheckedIdInstances = [
          ...defaultCheckedIdInstances,
          ...item.listIdsInstance,
        ];
      });

      this.setState(
        {
          params: {
            ...this.state.params,
            field_main_work_type_id,
            field_sub_work_type_id,
            a_item_list_select_flag,
            b_item_list_select_flag,
            c_item_list_select_flag,
            d_item_list_select_flag,
            a_item_ids,
            b_item_ids,
            c_item_ids,
            d_item_ids,
            a_item_list_required_flag,
            b_item_list_required_flag,
            c_item_list_required_flag,
            d_item_list_required_flag,
            man_day_input_flag,
          },
          fieldSubWorkType: field_sub_work_type,
          fieldMainWorkType: field_main_work_type,
          isSubWorkType: !_.isEmpty(field_sub_work_type),
          allClassItems,
          defaultRequired,
          defaultCheckedIdInstances,
          titleMainSub: _.isNull(field_sub_work_type)
            ? `（${field_main_work_type.name}）`
            : `（${field_main_work_type.name} - ${field_sub_work_type.name}）`,
        },
        () => {
          this.getListLocation(true);
        }
      );
      this.isVisibleConfirmDialog = true;
    } else {
      this.setState({
        isShowPopupError: true,
        messageError: _.get(response, 'data.message'),
      });
    }
  };

  getListClassLocation = async () => {
    const allClassItems = _.cloneDeep(this.state.allClassItems);
    const response = await FieldService.fieldItem(this.fieldId);
    if (response.result) {
      const fieldItem = _.get(response, 'data.entities.field_item');
      for (
        let i = NUMBER_OF_FIELD_ITEM_TYPE.itemA;
        i <= NUMBER_OF_FIELD_ITEM_TYPE.itemD;
        i++
      ) {
        if (
          _.isEqual(
            _.get(fieldItem, `field_item_list${i}_display_flag`),
            DISPLAY_FLAG.use.id
          )
        ) {
          allClassItems.push({
            id: i,
            name: _.get(fieldItem, `field_item_list${i}_title`),
          });
        }
      }
      this.setState({ allClassItems });
    }
  };

  getListLocation = async (isChecked = false, classId = null) => {
    const { defaultCheckedIdInstances, defaultRequired } = this.state;
    const params = _.cloneDeep(this.state.params);
    const item_list_ids = [];
    const allClassItems = _.cloneDeep(this.state.allClassItems);
    const defaultListLocation = _.cloneDeep(this.state.defaultListLocation);
    const classIndex = _.findIndex(allClassItems, item =>
      _.isEqual(item.id, classId)
    );

    if (params.a_item_list_select_flag) {
      item_list_ids.push(NUMBER_OF_FIELD_ITEM_TYPE.itemA);
    }
    if (params.b_item_list_select_flag) {
      item_list_ids.push(NUMBER_OF_FIELD_ITEM_TYPE.itemB);
    }
    if (params.c_item_list_select_flag) {
      item_list_ids.push(NUMBER_OF_FIELD_ITEM_TYPE.itemC);
    }
    if (params.d_item_list_select_flag) {
      item_list_ids.push(NUMBER_OF_FIELD_ITEM_TYPE.itemD);
    }
    const paramsGetListLocation = {
      is_limit: 0,
      item_list_ids: _.isNull(classId) ? item_list_ids : [classId],
    };
    if (
      this.isCheckingCheckBoxFlag ||
      _.isEmpty(paramsGetListLocation.item_list_ids)
    ) {
      return;
    }
    const requireItemIndex = _.findIndex(defaultRequired, item =>
      _.isEqual(item.id, classId)
    );
    if (!isChecked) {
      allClassItems[classIndex].listInstances = [];
      this.validateAndRequireItems[requireItemIndex].validateMessage = null;
      this.validateAndRequireItems[requireItemIndex].placeItemRequiredFlag =
        defaultRequired[requireItemIndex].required;
    } else {
      this.isCheckingCheckBoxFlag = true;
      const response = await FieldItemService.list(
        this.fieldId,
        paramsGetListLocation
      );
      this.isCheckingCheckBoxFlag = false;
      if (response.result) {
        const listLocationData = _.get(response, 'data.entities');
        let listLocation = [
          ...listLocationData.field_item_a_lists,
          ...listLocationData.field_item_b_lists,
          ...listLocationData.field_item_c_lists,
          ...listLocationData.field_item_d_lists,
        ];
        _.forEach(listLocation, item => {
          let selected = false;
          selected = _.includes(defaultCheckedIdInstances, item.id);
          const index = _.findIndex(allClassItems, val =>
            _.isEqual(val.id, item.item_list_id)
          );
          allClassItems[index].listInstances.push({
            ...item,
            selected,
          });
          if (selected) {
            defaultListLocation.push(item);
          }
        });
      }
    }
    if (!_.isNull(classId)) {
      allClassItems[classIndex].isChecked = isChecked;
      switch (classId) {
        case NUMBER_OF_FIELD_ITEM_TYPE.itemA:
          params.a_item_list_select_flag = isChecked;
          params.a_item_list_required_flag = isChecked
            ? defaultRequired[requireItemIndex].required
            : isChecked;
          params.a_item_ids = isChecked
            ? this.handleListInstanceOfClass(
                allClassItems[classIndex].listInstances,
                isChecked
              )
            : [];
          break;
        case NUMBER_OF_FIELD_ITEM_TYPE.itemB:
          params.b_item_list_select_flag = isChecked;
          params.b_item_list_required_flag = isChecked
            ? defaultRequired[requireItemIndex].required
            : isChecked;
          params.b_item_ids = isChecked
            ? this.handleListInstanceOfClass(
                allClassItems[classIndex].listInstances,
                isChecked
              )
            : [];
          break;
        case NUMBER_OF_FIELD_ITEM_TYPE.itemC:
          params.c_item_list_select_flag = isChecked;
          params.c_item_list_required_flag = isChecked
            ? defaultRequired[requireItemIndex].required
            : isChecked;
          params.c_item_ids = isChecked
            ? this.handleListInstanceOfClass(
                allClassItems[classIndex].listInstances,
                isChecked
              )
            : [];
          break;
        case NUMBER_OF_FIELD_ITEM_TYPE.itemD:
          params.d_item_list_select_flag = isChecked;
          params.d_item_list_required_flag = isChecked
            ? defaultRequired[requireItemIndex].required
            : isChecked;
          params.d_item_ids = isChecked
            ? this.handleListInstanceOfClass(
                allClassItems[classIndex].listInstances,
                isChecked
              )
            : [];
          break;
        default:
          return null;
      }
    }
    this.setState({
      allClassItems,
      isDisplay: !_.isEmpty(
        _.filter(allClassItems, item => _.isEqual(item.isChecked, true))
      )
        ? true
        : false,
      defaultListLocation,
      params,
    });
  };

  getValidateMessage = classId => {
    const index = _.findIndex(this.validateAndRequireItems, item =>
      _.isEqual(item.id, classId)
    );
    return this.validateAndRequireItems[index].validateMessage;
  };

  handleGoBackDialog = () => {
    dialogLoader.show(CloseEditView, this.GoBack);
  };

  handleShowConfirmDialog = () => {
    const { params, defaultListLocation, allClassItems } = this.state;
    let numberOfEmptyInstances = 0;
    if (this.isVisibleConfirmDialog) {
      if (params.a_item_list_select_flag && _.isEmpty(params.a_item_ids)) {
        this.validateAndRequireItems[0].validateMessage = messageUtility.getMessage(
          'E-000-010'
        );
        numberOfEmptyInstances += 1;
      }
      if (params.b_item_list_select_flag && _.isEmpty(params.b_item_ids)) {
        this.validateAndRequireItems[1].validateMessage = messageUtility.getMessage(
          'E-000-010'
        );
        numberOfEmptyInstances += 1;
      }
      if (params.c_item_list_select_flag && _.isEmpty(params.c_item_ids)) {
        this.validateAndRequireItems[2].validateMessage = messageUtility.getMessage(
          'E-000-010'
        );
        numberOfEmptyInstances += 1;
      }
      if (params.d_item_list_select_flag && _.isEmpty(params.d_item_ids)) {
        this.validateAndRequireItems[3].validateMessage = messageUtility.getMessage(
          'E-000-010'
        );
        numberOfEmptyInstances += 1;
      }
      if (numberOfEmptyInstances > 0) {
        return this.setState({ keyRender: !this.state.keyRender });
      }
      let numberOfInstances = INIT_NUMBER_OF_INSTANCE;
      let listCheckedClass = [];
      _.forEach(allClassItems, classItem => {
        const listSelectedItems = _.filter(classItem.listInstances, item => {
          return item.selected;
        });
        if (!_.isEmpty(listSelectedItems)) {
          listCheckedClass = [...listCheckedClass, `「${classItem.name}」`];
          numberOfInstances *= _.size(listSelectedItems);
        }
      });
      const stringOfListCheckedClass = _.join(listCheckedClass, '×');
      const messageError = messageUtility.getMessage(
        'E-000-061',
        MAX_NUMBER_OF_INSTANCES,
        stringOfListCheckedClass
      );
      if (numberOfInstances > MAX_NUMBER_OF_INSTANCES) {
        return this.setState({
          isInvalidOfInstances: true,
          isShowPopupError: true,
          messageError,
        });
      }
      let deleteIdsClass = [];
      const deletedItems = [];
      const listAllInstanceIdOfWork = [
        ...params.a_item_ids,
        ...params.b_item_ids,
        ...params.c_item_ids,
        ...params.d_item_ids,
      ];
      _.forEach(defaultListLocation, item => {
        if (
          !_.includes(listAllInstanceIdOfWork, item.id) &&
          !_.includes(deleteIdsClass, item.item_list_id)
        ) {
          deleteIdsClass = [...deleteIdsClass, item.item_list_id];
        }
      });
      _.map(deleteIdsClass, item => {
        const classIndex = _.findIndex(allClassItems, itemClass =>
          _.isEqual(itemClass.id, item)
        );
        deletedItems.push({ id: item, name: allClassItems[classIndex].name });
      });
      if (_.isEmpty(deletedItems)) {
        return this.updateWorkTypeSettings();
      }
      this.setState(
        {
          deletedItems,
        },
        () => this.handleVisibleConfirmDialog(true)
      );
    }
  };

  handleChangeRequired = (checked, classId) => {
    const params = _.cloneDeep(this.state.params);
    const index = _.findIndex(this.validateAndRequireItems, item =>
      _.isEqual(item.id, classId)
    );
    this.validateAndRequireItems[index].placeItemRequiredFlag = checked;

    switch (classId) {
      case NUMBER_OF_FIELD_ITEM_TYPE.itemA:
        params.a_item_list_required_flag = checked;
        break;
      case NUMBER_OF_FIELD_ITEM_TYPE.itemB:
        params.b_item_list_required_flag = checked;
        break;
      case NUMBER_OF_FIELD_ITEM_TYPE.itemC:
        params.c_item_list_required_flag = checked;
        break;
      case NUMBER_OF_FIELD_ITEM_TYPE.itemD:
        params.d_item_list_required_flag = checked;
        break;
      default:
        return null;
    }
    this.setState({ params });
  };

  handleChangeManDayFlag = () => {
    const { params } = this.state;
    this.setState({
      params: {
        ...params,
        man_day_input_flag: !params.man_day_input_flag,
      },
    });
  };

  handleVisibleConfirmDialog = visibleConfirmDialog => {
    this.setState({
      visibleConfirmDialog,
    });
  };

  handleListInstanceOfClass = (listInstance, isChecked = null) => {
    const classItem = [];
    if (!_.isEmpty(listInstance)) {
      _.map(listInstance, item => {
        if (_.isNull(isChecked)) {
          classItem.push(item.id);
        }
        if (isChecked && item.selected) {
          classItem.push(item.id);
        }
      });
    }
    return classItem;
  };

  handleCheckListInstance = values => {
    const { checkedItems } = values;
    const params = _.cloneDeep(this.state.params);
    switch (values.selectedItem.item_list_id) {
      case NUMBER_OF_FIELD_ITEM_TYPE.itemA:
        params.a_item_ids = this.handleListInstanceOfClass(checkedItems);
        break;
      case NUMBER_OF_FIELD_ITEM_TYPE.itemB:
        params.b_item_ids = this.handleListInstanceOfClass(checkedItems);
        break;
      case NUMBER_OF_FIELD_ITEM_TYPE.itemC:
        params.c_item_ids = this.handleListInstanceOfClass(checkedItems);
        break;
      case NUMBER_OF_FIELD_ITEM_TYPE.itemD:
        params.d_item_ids = this.handleListInstanceOfClass(checkedItems);
        break;
      default:
        return null;
    }
    this.setState({ params });
  };

  handleClosePopupError = () => {
    this.setState({ isInvalidOfInstances: false, isShowPopupError: false });
  };

  setClassRequired = classId => {
    const index = _.findIndex(this.validateAndRequireItems, item =>
      _.isEqual(item.id, classId)
    );
    return this.validateAndRequireItems[index].placeItemRequiredFlag;
  };

  setMaxHeightTable = () => {
    const divFixed = document.querySelector('.fixed-scroller-header');
    const title = document.querySelector(
      '.ProgressSettingLocation .PageHeader__left-items'
    );
    const heightFixed = !this.strongNotification
      ? 45 + title.offsetHeight
      : 85 + title.offsetHeight;
    if (divFixed) {
      divFixed.style.maxHeight = `calc(100vh - ${heightFixed}px)`;
    }
  };

  navigateToSetting = classId => {
    window.location.href = `/conference/0:1/0/0/FieldAItems:${classId}/Dashboard:0`;
  };

  handleValidateClass = listInstances => {
    let validateMessage = null;
    validateMessage =
      _.size(listInstances) <= 0
        ? messageUtility.getMessage('E-000-010')
        : null;
    return validateMessage;
  };

  initialized = (Control, itemId) => {
    switch (itemId) {
      case NUMBER_OF_FIELD_ITEM_TYPE.itemA:
        this.listBoxClassA = Control;
        break;
      case NUMBER_OF_FIELD_ITEM_TYPE.itemB:
        this.listBoxClassB = Control;
        break;
      case NUMBER_OF_FIELD_ITEM_TYPE.itemC:
        this.listBoxClassC = Control;
        break;
      case NUMBER_OF_FIELD_ITEM_TYPE.itemD:
        this.listBoxClassD = Control;
        break;
      default:
        return null;
    }
  };

  onLostFocusSelectListBox = Control => {
    const positionClassInList = Control.selectedItem.item_list_id;
    const { params } = this.state;
    const classIndex = _.findIndex(this.validateAndRequireItems, item => {
      return _.isEqual(item.id, positionClassInList);
    });
    switch (positionClassInList) {
      case NUMBER_OF_FIELD_ITEM_TYPE.itemA:
        this.validateAndRequireItems[
          classIndex
        ].validateMessage = this.handleValidateClass(params.a_item_ids);
        break;
      case NUMBER_OF_FIELD_ITEM_TYPE.itemB:
        this.validateAndRequireItems[
          classIndex
        ].validateMessage = this.handleValidateClass(params.b_item_ids);
        break;
      case NUMBER_OF_FIELD_ITEM_TYPE.itemC:
        this.validateAndRequireItems[
          classIndex
        ].validateMessage = this.handleValidateClass(params.c_item_ids);
        break;
      case NUMBER_OF_FIELD_ITEM_TYPE.itemD:
        this.validateAndRequireItems[
          classIndex
        ].validateMessage = this.handleValidateClass(params.d_item_ids);
        break;
      default:
        return null;
    }
    this.setState({ keyRender: !this.state.keyRender });
  };

  formatItem = (listBox, formatItemEventArgs) => {
    const { data, item } = formatItemEventArgs;
    if (_.isEqual(data.display_flag, DISPLAY_FLAG.unused.id)) {
      item.classList.add('wj-disabled');
    }
  };

  render() {
    const {
      fieldMainWorkType,
      fieldSubWorkType,
      deletedItems,
      isSubWorkType,
      visibleConfirmDialog,
      params,
      isDisplay,
      messageError,
      isShowPopupError,
      allClassItems,
      isInvalidOfInstances,
      titleMainSub,
    } = this.state;
    let titleMessage = messageUtility.getMessage('E-001-402');
    if (isInvalidOfInstances) {
      titleMessage = messageUtility.getMessage('E-001-429');
    }
    return (
      <div className='master-slide-view show ProgressSettingLocation'>
        <Helmet>
          <link rel='icon' href={IconProgress} />
          <title>{TITLE_BROWSER_PROGRESS.progressSetting}</title>
        </Helmet>
        <div className='master-slide-view__view'>
          <MasterPageHeader
            title={`${
              HEADER_CONSTANTS_PROGRESS.progressSetting
            }${titleMainSub}`}
            disableHelpMenu
          />
          <div className='master-slide-view__table fixed-scroller-header'>
            <HeaderMenu
              confirmUpdate={this.handleShowConfirmDialog}
              goBack={this.handleGoBackDialog}
              isDisabledUpdate={false}
            />
            <ProgressConfirmDialog
              visible={visibleConfirmDialog}
              negativeButtonClassName='btn--effective'
              fieldMainWorkType={fieldMainWorkType}
              fieldSubWorkType={fieldSubWorkType}
              listWorkDelete={deletedItems}
              isSubWorkType={isSubWorkType}
              type='location'
              onConfirm={this.updateWorkTypeSettings}
              onCancel={() => this.handleVisibleConfirmDialog(false)}
            />
            <Information
              visible={isShowPopupError}
              message={messageError}
              title={titleMessage}
              multilineText={true}
              buttonText={messageUtility.getMessage('I-000-008')}
              onClose={() => {
                isInvalidOfInstances
                  ? this.handleClosePopupError()
                  : this.GoBack.callback.clear();
              }}
            />
            <div className='ProgressSettingLocation--border' />
            <div className='ProgressSettingLocation--description'>
              <Description>
                <span>計画の入力方法を設定してください。</span>
                <br />
                <span>
                  作業場所単位で計画を管理する場合は、「入力方法」の「集計対象とする作業場所」を設定してください。
                </span>
              </Description>
            </div>
            <div className='master-slide-view__body'>
              <FormList>
                <FormListSubHeader
                  title='工種情報'
                  noMarginTop={true}
                  info='場所を設定する工種の情報です。この内容は変更できません。'
                />
                <FormListItem label='大工種' isBorder={true}>
                  <FormElement>{fieldMainWorkType.name}</FormElement>
                </FormListItem>
                <FormListItem label='小工種' isBorder={true}>
                  <FormElement>
                    {isSubWorkType ? fieldSubWorkType.name : '--'}
                  </FormElement>
                </FormListItem>
                <FormListItem label='出来高数量単位' isBorder={true}>
                  <FormElement>
                    {isSubWorkType
                      ? fieldSubWorkType.unit_name
                      : fieldMainWorkType.unit_name}
                  </FormElement>
                </FormListItem>
                <FormListSubHeader title='入力方法' />
                <FormListItem label='計画歩掛・計画人工の入力'>
                  <FormElement info='工種ごとに入力しやすい方を選択してください。選択されなかった方は自動的に計算されます。'>
                    <div className='form-list-radio'>
                      <div className='form-list-radio__item'>
                        <label className='radio'>
                          <InputForm
                            type='radio'
                            value={!params.man_day_input_flag}
                            onUpdate={this.handleChangeManDayFlag}
                          />
                          <RadioButtonIcon className='icon--2x' />
                          <span>歩掛を入力する</span>
                        </label>
                      </div>
                      <div className='form-list-radio__item'>
                        <label className='radio'>
                          <InputForm
                            type='radio'
                            value={params.man_day_input_flag}
                            onUpdate={this.handleChangeManDayFlag}
                          />
                          <RadioButtonIcon className='icon--2x' />
                          <span>人工を入力する</span>
                        </label>
                      </div>
                    </div>
                  </FormElement>
                </FormListItem>
                <FormListItem label='集計対象とする作業場所' isBorder={true}>
                  <FormElement info='作業場所の登録・編集は、調整会議の各種設定から行えます。'>
                    {_.map(allClassItems, item => {
                      if (!_.isUndefined(item)) {
                        const { id, name, isChecked } = item;
                        return (
                          <div
                            className='ProgressSettingLocation--checkbox'
                            key={id}
                          >
                            <label className='checkbox value-table'>
                              <input
                                name='checkbox'
                                type='checkbox'
                                disabled={false}
                                checked={isChecked}
                                onChange={e =>
                                  this.getListLocation(e.target.checked, id)
                                }
                              />
                              <i className='i-square i-3x' />
                              <ToolTip content={name} value={name} />
                            </label>
                          </div>
                        );
                      }
                    })}
                  </FormElement>
                </FormListItem>
                {isDisplay && (
                  <FormListItem label={'使用する作業場所'} required={true}>
                    <FormElement>
                      {_.map(allClassItems, item => {
                        const { id, name, listInstances, isChecked } = item;
                        const listUnusedInstances = _.filter(
                          listInstances,
                          instance =>
                            _.isEqual(
                              instance.display_flag,
                              DISPLAY_FLAG.unused.id
                            )
                        );
                        if (isChecked) {
                          return (
                            <FormListItem
                              required={true}
                              isBorder={false}
                              key={id}
                            >
                              <FormElement>
                                <div className='form-list__element__header value-table'>
                                  <span className='header-item'>
                                    <ToolTip content={name} value={name} />
                                  </span>
                                  {!_.isEmpty(listInstances) ? (
                                    <FormListItem isBorder={false}>
                                      <FormElement
                                        info=''
                                        className='form-list__required'
                                      >
                                        <label className='checkbox'>
                                          <input
                                            type='checkbox'
                                            checked={this.setClassRequired(id)}
                                            onChange={e =>
                                              this.handleChangeRequired(
                                                e.target.checked,
                                                id
                                              )
                                            }
                                          />
                                          <i
                                            className='i-square i-3x'
                                            aria-hidden='true'
                                          />
                                          <span>
                                            作業場所の入力を必須にする
                                          </span>
                                        </label>
                                        <label className='description'>
                                          <span>
                                            チェックすると、調整会議の作業予定・実績でこの工種が選択された場合に、作業場所の入力が必須になります。
                                          </span>
                                        </label>
                                        <FormListItem
                                          className='ProgressSettingLocation--validate'
                                          isBorder={false}
                                        >
                                          <FormElement
                                            validate={this.getValidateMessage(
                                              id
                                            )}
                                          >
                                            <div className='element-bottom'>
                                              <ListBox
                                                initialized={s =>
                                                  this.initialized(s, id)
                                                }
                                                checkedMemberPath='selected'
                                                itemsSource={listInstances}
                                                displayMemberPath='name'
                                                checkedItemsChanged={
                                                  this.handleCheckListInstance
                                                }
                                                lostFocus={
                                                  this.onLostFocusSelectListBox
                                                }
                                                formatItem={this.formatItem}
                                                wjItemTemplate={context => {
                                                  const {
                                                    id,
                                                    display_flag,
                                                  } = context.item;
                                                  const isDisplayFlg = _.isEqual(
                                                    display_flag,
                                                    DISPLAY_FLAG.use.id
                                                  );
                                                  return (
                                                    <React.Fragment>
                                                      <label
                                                        htmlFor={`${id}`}
                                                        className='checkbox'
                                                      >
                                                        <input
                                                          type='checkbox'
                                                          id={`${id}`}
                                                          disabled={
                                                            !isDisplayFlg
                                                          }
                                                          defaultChecked={_.get(
                                                            context,
                                                            'item.selected'
                                                          )}
                                                        />
                                                        <i
                                                          className={
                                                            isDisplayFlg
                                                              ? 'i-square i-3x'
                                                              : 'i-square-disabled i-3x'
                                                          }
                                                          aria-hidden='true'
                                                        />
                                                        <ToolTip
                                                          value={
                                                            isDisplayFlg
                                                              ? _.get(
                                                                  context,
                                                                  'item.name'
                                                                )
                                                              : `${_.get(
                                                                  context,
                                                                  'item.name'
                                                                )}（未使用）`
                                                          }
                                                          content={_.get(
                                                            context,
                                                            'item.name'
                                                          )}
                                                        />
                                                      </label>
                                                    </React.Fragment>
                                                  );
                                                }}
                                              />
                                            </div>
                                          </FormElement>
                                        </FormListItem>
                                        {!_.isEmpty(listUnusedInstances) && (
                                          <label className='description'>
                                            <span>
                                              調整会議でステータスを「未使用」にした作業場所は設定の変更ができません。ステータスを変更する場合には
                                              <a
                                                onClick={() =>
                                                  this.navigateToSetting(id)
                                                }
                                                className='clickable-text'
                                              >
                                                こちら
                                              </a>
                                              から変更してください。
                                            </span>
                                          </label>
                                        )}
                                      </FormElement>
                                    </FormListItem>
                                  ) : (
                                    <FormListItem
                                      className='ProgressSettingLocation--empty'
                                      isBorder={false}
                                    >
                                      <FormElement
                                        validate={
                                          this.getValidateMessage(id) ||
                                          _.isEmpty(listInstances)
                                        }
                                      >
                                        <span className='form-list__empty-location'>
                                          {name}が登録されていません。
                                          <a
                                            onClick={() =>
                                              this.navigateToSetting(id)
                                            }
                                            className='clickable-text'
                                          >
                                            調整会議の各種設定
                                          </a>
                                          から登録を行うか、他の作業場所を選択してください。
                                        </span>
                                      </FormElement>
                                    </FormListItem>
                                  )}
                                </div>
                              </FormElement>
                            </FormListItem>
                          );
                        }
                      })}
                    </FormElement>
                  </FormListItem>
                )}
              </FormList>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ProgressSettingLocation.jsx